import {
  DeviceTypeEnum,
  SCREEN_WIDTH_BREAKPOINTS,
} from "@/constants/constants";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

export const useDeviceType = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  const _isMobile = useMediaQuery({
    query: `(min-width: ${SCREEN_WIDTH_BREAKPOINTS[DeviceTypeEnum.MOBILE].min}px) and (max-width: ${SCREEN_WIDTH_BREAKPOINTS[DeviceTypeEnum.MOBILE].max}px)`,
  });

  const _isDesktop = useMediaQuery({
    query: `(min-width: ${SCREEN_WIDTH_BREAKPOINTS[DeviceTypeEnum.DESKTOP].min}px)`,
  });

  useEffect(() => {
    // this is required to prevent hydration errors
    setIsMobile(_isMobile);
    setIsDesktop(_isDesktop);
  }, [_isMobile, _isDesktop]);

  return {
    isMobile,
    isDesktop,
  };
};
